import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Flight, BookedTrip } from '@ibe/models';
import { SidebarService } from '@ibe/services/ui';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromStore from '../../../../../store';
import { takeWhile } from 'rxjs/operators';

@Component({
	selector: 'app-details-changes',
	templateUrl: './details-changes.component.html',
	styleUrls: ['./details-changes.component.scss']
})
export class DetailsChangesComponent implements OnInit, OnDestroy {


	flight: Flight;
	flight$: Observable<Flight>;
	_hasEdit = false;
	flightIdentifier: string;
	isMYB: boolean = false;
	bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	booking: BookedTrip;
	isAlive: boolean = true;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		private store: Store<fromStore.State>
	) {
		this.bookedTrip$.pipe(takeWhile(() => this.isAlive)).subscribe(value => this.booking = value);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			this.flightIdentifier = params.flight;
			this.flight$ = this.store.pipe(select(fromStore.getFlight, { id: this.flightIdentifier }));

			this.flight$.subscribe(value => {
				if (value) {

					this.flight = value;
					this._hasEdit = value.canEditPassengerInfo() || false;
				}

				if (this.router.url.includes('/my-bookings/view/')) this._hasEdit = false;
				if (this.router.url.includes('/my-bookings/')) this.isMYB = true;

			});

		});
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	/** Handles close action intention **/
	TAP_handleClose() { this.closeSidebar(); }

	TAP_printName(passenger) {

		if (passenger) {
			let SALUTATION = '';
			let NAME = ' Adult 1';
			if (passenger.gender && passenger.gender == 'female') {
				SALUTATION = 'Mrs.';
			}

			if (passenger.gender && passenger.gender == 'male') {
				SALUTATION = 'Mrs.';
			}

			if (passenger.type) {
				NAME = (passenger.type.charAt(0)).toUpperCase() + passenger.type.slice(1) + ' ' + passenger.typeCount;
			}

			if (passenger.name) {
				NAME = passenger.name;
			}

			return SALUTATION + ' ' + NAME;
		} else {
			return 'Adult 1';
		}
	}

	TAP_printBrand(): string {
		if (this.flight)
			return this.flight.options.brand.replace(/[\-_]/g, ' ');
		else return '';
	}
	ngOnDestroy() {
		this.isAlive = false;
	}
}
